import { defineComponent } from 'vue';
import { defineRule, ErrorMessage, Field, } from 'vee-validate/compat';
import DatePicker from '@common/datepicker/DatePicker.vue';
import validation from '@common/mixins/validation';
import Validator from '@common/veeValidate/Validator';
import { translator } from '~/zf/frontend/common/mixins';
export default defineComponent({
    name: 'EndDate',
    components: { DatePicker, Field, ErrorMessage },
    compatConfig: {
        MODE: 3,
    },
    mixins: [translator, validation],
    props: {
        modelValue: {
            type: Date,
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            Validator,
        };
    },
    created() {
        this.defineValidatorRule();
    },
    methods: {
        defineValidatorRule() {
            const endDateAfterNow = (endDate) => {
                if (endDate > new Date()) {
                    return true;
                }
                return this.tr('viiu.componentMuting.END_DATE_AFTER_NOW');
            };
            defineRule('end_time_before_now', endDateAfterNow);
        },
    },
});
